// document.addEventListener('DOMContentLoaded', () => {
//     const wrapGift = document.querySelector('.lagarh-gift-wrapping');
//     if (wrapGift) {
//         const form = wrapGift.closest('form[action="/cart/add"]');
//         const submitButton = form.querySelector('[data-submit-button]');
//         const checkGift = document.querySelector('.check-add-gift');
//         if (checkGift.checked && submitButton) {
//             submitButton.addEventListener('click', function(event) {
//                 event.preventDefault();
//                 console.log('A submissão foi bloqueada.');
//             });
//         }
//     }
// })

const checkChars = (event, maxChar) => {
    const elQty = document.querySelector('.qty-char');
    if(elQty){
        const qty = Number(elQty.innerHTML);
        const value = event.target.value;
        if(value == ''){
            elQty.innerHTML = maxChar;
        }else{
            const qtyField = event.target.value.length;
            elQty.innerHTML = maxChar - qtyField;
        }

    }
}

const generateCode = () => {
    const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        second: 'numeric'
    };
    const date = new Date();
    const formattedDate = new Intl.DateTimeFormat('pt-BR', options).format(date);
    const dateSave = formattedDate.replaceAll('/', '').replace(', ', '');
    const random = Math.floor(Math.random() * 1000000);
    return dateSave + random;
}

const lagarhGiftWrap = (event) => {
    const checked = event.target.checked;
    const messageField = document.querySelector('#gift-wrap-message');
    const wrapGiftMessage = document.querySelector('.wrap-message-gift');

    if(checked) {
        // const randonCode = generateCode();
        wrapGiftMessage.classList.remove('hide-el');
        const wrapGift = document.querySelector('.lagarh-gift-wrapping');
        const form = wrapGift.closest('form[action="/cart/add"]');
        const quantity = Number(form.querySelector('[name="quantity"]').value);
        const submitButton = form.querySelector('[data-submit-button]');
        const parentButton = submitButton.parentNode;
        const fakeSubmit = submitButton.cloneNode(true);
        messageField.removeAttribute('disabled');
        document.querySelector('.prop-wrap-product').removeAttribute('disabled');
        fakeSubmit.classList.add('gift-wrap-button');
        fakeSubmit.addEventListener('click', (e) => {
            e.preventDefault();
            if(messageField.value === '') {
                Swal.fire("Você precisa digitar uma mensagem ou selecionar a opção Deixar em branco para continuar!")
            } else {
            const giftId = Number(wrapGift.attributes.getNamedItem('data-gift-id').value);
            const productName = wrapGift.attributes.getNamedItem('data-gift-product-name').value;
            const properties = {
                'Produto': productName
                // 'Produto': `${productName} - #${randonCode}`
            }
            if(messageField && messageField.value != ''){
                properties['Mensagem'] = messageField.value;
            }
            const formData = {
                'items': [{
                    'id': giftId,
                    'quantity': quantity,
                    'properties': properties
                }]
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                  console.log('Embalagem de presente adicionada ao carrinho:', data);
                  setTimeout(() => {
                    submitButton.click();
                  }, 500);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    setTimeout(() => {
                        submitButton.click();
                    }, 500)
                });
            }
        });
        submitButton.classList.add('hide-el');
        parentButton.insertBefore(fakeSubmit, submitButton);
    }else{
        wrapGiftMessage.classList.add('hide-el');
        const removeFake = document.querySelector('.gift-wrap-button');
        const backSubmit = document.querySelector('.hide-el[data-submit-button]');
        document.querySelector('.prop-wrap-product').setAttribute('disabled', true);
        messageField.value = '';
        messageField.setAttribute('disabled', true);
        if(removeFake) {
            removeFake.remove();
        }
        if(backSubmit){
            backSubmit.classList.remove('hide-el');
        }
    }
}

const disableMessage = (event) => {
    const checked = event.target.checked;
    const messageEL = document.querySelector('#gift-wrap-message');
    if(checked){
        messageEL.value = "* em branco *";
        messageEL.setAttribute("readonly", true);
    } else {
        messageEL.value = "";
        messageEL.removeAttribute("readonly");
    }
}